import React from "react";
import { CustomerContractPriceListFormStore } from "./CustomerContractPriceListFormStore";

export const CustomerContractPriceListFormContext =
  React.createContext<CustomerContractPriceListFormStore>(null);
